import { createApi } from './api';

const getLocationFromArea = area => {
  if (!area) {
    return null;
  }

  return {
    label: area.name,
    type: area.type || 'wkda',
    lat: area.lat,
    lng: area.lng
  };
};

export function create(config) {
  let axiosConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const api = createApi(config.baseApiUrl, config, axiosConfig);
  return {
    searchBranches: _ref => {
      let {
        area,
        ipAddress,
        hash,
        limit = config.branchSearchLimit,
        slotAvailabilityMaxDays = config.multiBranchWidget.slotAvailabilityMaxDays
      } = _ref;
      return api.searchBranches({
        location: getLocationFromArea(area),
        hash,
        limit,
        specialAreas: config.specialAreas || [],
        ipAddress,
        enableBranchPreselection: true,
        slotAvailabilityMaxDays
      }).then(res => res.data);
    },
    searchClosestBranches: _ref2 => {
      let {
        carleadId,
        countryCode,
        distance = config.closestBranchesSearchDistance || 150,
        limit = config.closestBranchesSearchLimit || 3
      } = _ref2;
      return api.searchClosestBranches({
        carleadId,
        countryCode,
        distance,
        limit
      }).then(res => res.data);
    }
  };
}